export const userBlockedError = 'user_blocked';
export const wrongPartnerError = 'invalid_partner';

const errorsWithoutNotification = [userBlockedError, wrongPartnerError];

export const shouldHideNotification = (errorType: string) =>
    errorsWithoutNotification.includes(errorType);
